import { forwardRef } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { useApp } from 'common/AppContext';

// Dashboard
import { AuthCallback, Authentication } from "pages/auth";
import DashboardLayout from "pages/dashboard/DashboardLayout";
import Logout from "pages/logout/Logout";

// Streaming experience
import Queue from "pages/queue/Queue";
import { Player } from "pages/player";
import SessionLimit from "pages/session_limit/SessionLimit";

// Other
import { E404 } from "pages/error/E404";

const DashboardRedirect = () => (<Redirect to="/dashboard" />);

export const AppRouter = forwardRef((props, forwardedRef) => {

    const { isLoggedIn } = useApp();

    return (
        <Router ref={forwardedRef}>
            <div id="root_router">
                <Switch>

                    {/* Authentication */}
                    <Route path="/authenticate" exact component={Authentication} />
                    <Route path="/authenticate/callback" exact component={AuthCallback} />

                    {/* Home page */}
                    <Route path="/" exact component={isLoggedIn ? DashboardRedirect : Authentication} />

                    {/* Dashboard (shared Sidebar layout) */}
                    <Route path="/dashboard" component={isLoggedIn ? DashboardLayout : Authentication}/>
                    <Route path="/logout" exact component={Logout}/>

                    {/* Player */}
                    <Route path="/player/:session_guid" exact component={Player} />

                    {/* Queue */}
                    <Route path="/queue/:queue_guid" exact component={Queue} />

                    {/* Session limit (too many concurrent cloud sessions) */}
                    <Route path="/session-limit" exact component={SessionLimit} />

                    {/* Error handling */}
                    <Route path="/error" exact component={Error} />

                    <Route component={E404} />

                </Switch>
            </div>
        </Router>
    );

});